var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrvBenefitGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.5C21.8 4.5 20 4.4 20 2.5C20 2.2 19.8 2 19.5 2C19.2 2 19 2.2 19 2.5C19 2.7 18.9 4.5 17 4.5C16.7 4.5 16.5 4.7 16.5 5C16.5 5.3 16.7 5.5 17 5.5C17.2 5.5 19 5.6 19 7.5C19 7.8 19.2 8 19.5 8C19.8 8 20 7.8 20 7.5C20 7.3 20.1 5.5 22 5.5C22.3 5.5 22.5 5.3 22.5 5C22.5 4.7 22.3 4.5 22 4.5Z",
    fill: "#6E6E6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.5C19.8 17.5 18 17.4 18 15.5C18 15.2 17.8 15 17.5 15C17.2 15 17 15.2 17 15.5C17 15.7 16.9 17.5 15 17.5C14.7 17.5 14.5 17.7 14.5 18C14.5 18.3 14.7 18.5 15 18.5C15.2 18.5 17 18.6 17 20.5C17 20.8 17.2 21 17.5 21C17.8 21 18 20.8 18 20.5C18 20.3 18.1 18.5 20 18.5C20.3 18.5 20.5 18.3 20.5 18C20.5 17.7 20.3 17.5 20 17.5Z",
    fill: "#6E6E6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 11.9C19.2 11.6 19.2 10.4 18.4 10.1L14.2 8.7C13.3 8.4 12.6 7.7 12.3 6.8L10.9 2.6C10.7 2.2 10.4 2 10 2C9.6 2 9.3 2.2 9.1 2.6L7.7 6.8C7.4 7.7 6.7 8.4 5.8 8.7L1.6 10.1C0.8 10.4 0.8 11.6 1.6 11.9L5.8 13.3C6.7 13.6 7.4 14.3 7.7 15.2L9.1 19.4C9.3 19.8 9.6 20 10 20C10.4 20 10.7 19.8 10.9 19.4L12.3 15.2C12.6 14.3 13.3 13.6 14.2 13.3L18.4 11.9Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrvBenefitGray);
export default __webpack_public_path__ + "static/media/grv-benefit-gray.c5e3e71ae6d6ac884e7fc9c73f123ab6.svg";
export { ForwardRef as ReactComponent };